// Pre-launch world: Chapter I archive entries + journal. Garments stay hidden until reveal phases.

export const LAUNCH_LABEL = "26 November 2026";
export const LAUNCH_SHORT = "26.11.2026";

export const ARCHIVE_ENTRIES = [
  {
    slug: "rooted-fear",
    number: "001",
    title: "Rooted Fear",
    status: "Sealed",
    fragment: "/art/bloom.png",
    fragmentAlt: "Fragment of the original Rooted Fear artwork by Black Dog Society",
    position: "30% 20%",
    line: "What grows inside you never leaves.",
    medium: "Ink and graphite on paper",
    whisper: "The artist drew it three times before letting it keep its mouth. The first two are ash.",
    story: [
      "Rooted Fear began as a flower. It didn't stay one. Somewhere between the first line and the last, the petals opened into a mouth, and the stem became something closer to a spine.",
      "It is a drawing about the things planted in us early — the fears that were watered before we were old enough to name them. They grow downward as much as upward. They hold on.",
      "Rooted Fear is the first work of Chapter I. What it becomes, and how it is worn, remains sealed until 26 November 2026.",
    ],
  },
  {
    slug: "the-watcher",
    number: "002",
    title: "The Watcher",
    status: "Sealed",
    fragment: "/art/static.png",
    fragmentAlt: "Fragment of the original The Watcher artwork by Black Dog Society",
    position: "60% 30%",
    line: "It watches from behind your eyes, and never blinks.",
    medium: "Ink on paper",
    whisper: "There were meant to be two eyes. Look again at where the second one should be.",
    story: [
      "The Watcher is the quietest work in Chapter I, and the hardest one to be alone with. Big eyes. Small voice. The part of you that only observes — cataloguing every room, every conversation, every version of yourself you perform.",
      "It was drawn slowly, dot by dot, on the kind of night where the house is silent but your head isn't.",
      "The Watcher is the second work of Chapter I. It stays sealed until 26 November 2026.",
    ],
  },
  {
    slug: "the-crawler",
    number: "003",
    title: "The Crawler",
    status: "Sealed",
    fragment: "/art/the-quiet-one.png",
    fragmentAlt: "Fragment of the original The Crawler artwork by Black Dog Society",
    position: "50% 18%",
    line: "The thing you buried learned to crawl.",
    medium: "Ink on paper",
    whisper: "It was finished at 4:11am. The clock in the studio has read 4:11 ever since.",
    story: [
      "You can bury a feeling. You cannot teach it to stay down. The Crawler is about the weight that comes back — slower than it left, lower to the ground, patient.",
      "Of the three works in Chapter I, this is the heaviest. It was always going to be. Some things need more fabric to carry.",
      "The Crawler is the third and final work of Chapter I. Sealed until 26 November 2026.",
    ],
  },
];

export const JOURNAL_ENTRIES = [
  {
    slug: "why-chapter-i-exists",
    number: "N.001",
    title: "Why Chapter I Exists",
    date: "2026-06-14",
    dateLabel: "June 2026",
    excerpt: "Three works. Three hundred pieces. One beginning. Why Black Dog Society starts with a chapter, not a collection.",
    body: [
      "Most labels launch with a collection. We are starting with a chapter, because chapters belong to stories, and Black Dog Society is a story before it is anything else.",
      "Chapter I is three works: Rooted Fear, The Watcher, The Crawler. Each one began as a drawing made on a night when talking wasn't possible. Each will exist in a strictly limited number of pieces — three hundred across the chapter — and each piece will be numbered, recorded, and archived.",
      "The black dog is an old name for depression. Churchill used it. So do we. The difference is that we decided to stop pretending the dog isn't in the room. We drew it instead.",
      "Chapter I arrives 26 November 2026. It will not be reprinted. When it's gone, it enters the Archive, and the Society moves to Chapter II.",
    ],
  },
  {
    slug: "from-drawing-to-garment",
    number: "N.002",
    title: "From Drawing to Garment",
    date: "2026-06-21",
    dateLabel: "June 2026",
    excerpt: "Paper first. Fabric later. How an original Black Dog Society drawing earns the right to be worn.",
    body: [
      "Everything we make starts on paper. Graphite first, then ink — no screens, no shortcuts. If a drawing doesn't hold up on a wall, it doesn't deserve to be on a body.",
      "A drawing spends weeks as just a drawing. We live with it. Most don't survive that stage. The ones that do get translated — not resized, translated — for fabric: line weights rebuilt for print, textures re-cut for thread, compositions re-balanced for the way cloth moves.",
      "The garments themselves are built heavy on purpose. Weight is part of the language. You should feel what you're carrying.",
      "The full process — fabric, construction, print — will be shown as Chapter I approaches. For now, the paper comes first. It always will.",
    ],
  },
];
